import React, { Component } from 'react'

import { Search } from '../../components/Icons'
import { Container, IconContainer, StyledInput } from './styles'

class SearchInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focussed: false
    }
  }

  handleFocus() {
    this.setState({ focussed: true })
  }

  handleBlur() {
    this.setState({ focussed: false })
  }

  render() {
    const placeholder = this.props.placeholder ? this.props.placeholder : 'Zoeken'

    return (
      <Container active={this.state.focussed} large={this.props.large}>
        <IconContainer>
          <Search size="" />
        </IconContainer>

        <StyledInput
          type="text"
          name="search"
          placeholder={placeholder}
          value={this.props.query}
          onChange={e => {
            this.props.onSearch(e, this.props.products)
          }}
          onFocus={this.handleFocus.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          size="8"
        />
      </Container>
    )
  }
}

export default SearchInput



// WEBPACK FOOTER //
// ./src/components/SearchInput/index.js